var map = {
	"./apps/apps.module": [
		"./src/app/apps/apps.module.ts",
		"default~apps-apps-module~forms-forms-module",
		"common",
		"apps-apps-module"
	],
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"default~authentication-authentication-module~forms-forms-module",
		"common",
		"authentication-authentication-module"
	],
	"./charts/chartslib.module": [
		"./src/app/charts/chartslib.module.ts",
		"default~charts-chartslib-module~dashboards-dashboards-module",
		"default~charts-chartslib-module~material-component-material-module",
		"common",
		"charts-chartslib-module"
	],
	"./dashboards/dashboards.module": [
		"./src/app/dashboards/dashboards.module.ts",
		"default~charts-chartslib-module~dashboards-dashboards-module",
		"common",
		"dashboards-dashboards-module"
	],
	"./datatables/datatables.module": [
		"./src/app/datatables/datatables.module.ts",
		"default~datatables-datatables-module~pages-pages-module",
		"common",
		"datatables-datatables-module"
	],
	"./forms/forms.module": [
		"./src/app/forms/forms.module.ts",
		"default~apps-apps-module~forms-forms-module",
		"default~authentication-authentication-module~forms-forms-module",
		"common",
		"forms-forms-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./material-component/material.module": [
		"./src/app/material-component/material.module.ts",
		"default~charts-chartslib-module~material-component-material-module",
		"common",
		"material-component-material-module"
	],
	"./multi-dropdown/multi-dd.module": [
		"./src/app/multi-dropdown/multi-dd.module.ts",
		"multi-dropdown-multi-dd-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~datatables-datatables-module~pages-pages-module",
		"common",
		"pages-pages-module"
	],
	"./tables/tables.module": [
		"./src/app/tables/tables.module.ts",
		"common",
		"tables-tables-module"
	],
	"./widgets/widgets.module": [
		"./src/app/widgets/widgets.module.ts",
		"widgets-widgets-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;